define('modules/form_editor/views/preview_custom_separator',['require','exports','module','./preview_base','ldsh!../templates/preview_custom_separator'],function(require, exports, module){
  "use strict";
  var InputBase = require("./preview_base");
  module.exports = InputBase.extend({
    template: require("ldsh!../templates/preview_custom_separator")
  });
});

